module.exports = __webpack_public_path__ + "4cc79c81568bf56add969dc54693c3b7.svg";